module.exports = __webpack_public_path__ + "img/fab-linkedin-square.592cdfd4.svg";